exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#users_page .fa-trash-o[data-v-625cb2ad] {\n  font-size: 1.4rem;\n  padding: 0.1rem;\n}\n#users_page button[data-v-625cb2ad]:disabled {\n  cursor: not-allowed;\n}\n#users_page button[data-v-625cb2ad]:disabled:hover {\n  color: white;\n}", ""]);

// exports
